import {
  cilAddressBook,
  cilArrowThickLeft,
  cilArrowThickRight,
  cilArrowThickToLeft,
  cilArrowThickToRight,
  cilBan,
  cilBank,
  cilBeachAccess,
  cilBellExclamation,
  cilBuilding,
  cilCalculator,
  cilCalendar,
  cilCart,
  cilChart,
  cilChartLine,
  cilChevronBottom,
  cilChevronTop,
  cilCloudDownload,
  cilCoffee,
  cilDescription,
  cilFile,
  cilFilter,
  cilEnvelopeClosed,
  cilEuro,
  cilFingerprint,
  cilFolderOpen,
  cilHighlighter,
  cilHttps,
  cilImage,
  cilLan,
  cilLibraryAdd,
  cilLockLocked,
  cilLockUnlocked,
  cilMagnifyingGlass,
  cilMediaSkipBackward,
  cilMediaSkipForward,
  cilMoon,
  cilPaperclip,
  cilPeople,
  cilPrint,
  cilReload,
  cilSave,
  cilSettings,
  cilShare,
  cilShieldAlt,
  cilSpeedometer,
  cilStorage,
  cilSun,
  cilSync,
  cilTerminal,
  cilText,
  cilThumbDown,
  cilThumbUp,
  cilTrash,
  cilUser,
  cilUserPlus,
  cilWarning,
  cilWindow
} from '@coreui/icons'

export const iconsSet = Object.assign({}, {
  cilAddressBook,
  cilArrowThickLeft,
  cilArrowThickRight,
  cilArrowThickToLeft,
  cilArrowThickToRight,
  cilBan,
  cilBank,
  cilBeachAccess,
  cilBellExclamation,
  cilBuilding,
  cilCalculator,
  cilCalendar,
  cilCart,
  cilChart,
  cilChartLine,
  cilChevronBottom,
  cilChevronTop,
  cilCloudDownload,
  cilCoffee,
  cilDescription,
  cilFile,
  cilFilter,
  cilEnvelopeClosed,
  cilEuro,
  cilFingerprint,
  cilFolderOpen,
  cilHighlighter,
  cilHttps,
  cilImage,
  cilLan,
  cilLibraryAdd,
  cilLockLocked,
  cilLockUnlocked,
  cilMagnifyingGlass,
  cilMediaSkipBackward,
  cilMediaSkipForward,
  cilMoon,
  cilPaperclip,
  cilPeople,
  cilPrint,
  cilReload,
  cilSave,
  cilSettings,
  cilShare,
  cilShieldAlt,
  cilSpeedometer,
  cilStorage,
  cilSun,
  cilSync,
  cilTerminal,
  cilText,
  cilThumbDown,
  cilThumbUp,
  cilTrash,
  cilUser,
  cilUserPlus,
  cilWarning,
  cilWindow
})
